import { render, staticRenderFns } from "./tabelaGanhadoes.vue?vue&type=template&id=ef0f7bec&scoped=true&"
import script from "./tabelaGanhadoes.vue?vue&type=script&lang=js&"
export * from "./tabelaGanhadoes.vue?vue&type=script&lang=js&"
import style0 from "./tabelaGanhadoes.vue?vue&type=style&index=0&id=ef0f7bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0f7bec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardTitle,VDataTable,VEditDialog})
